import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';
import Footer from '../components/Footer';
import '../styles/Legal.css';

const UPDATED = '01.06.2025';

export default function KvkkPage() {
  const { t } = useI18n();

  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="legal-header-inner">
          <Link to="/" className="legal-back-link">← {t('common.backToHome')}</Link>
          <span className="legal-header-title">{t('legal.kvkk')}</span>
        </div>
      </header>

      <main className="legal-content">
        <span className="legal-badge">KVKK</span>
        <h1 className="legal-title">Kişisel Verilerin Korunması Aydınlatma Metni</h1>
        <p className="legal-meta">Son güncelleme: {UPDATED}</p>

        <div className="legal-highlight-box">
          <p>
            Bu aydınlatma metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu'nun 10. maddesi kapsamında veri
            sorumlusu sıfatıyla ViTex tarafından hazırlanmış olup, kişisel verilerinizin nasıl işlendiği hakkında
            sizi bilgilendirmek amacıyla sunulmaktadır.
          </p>
        </div>

        <div className="legal-section">
          <h2>1. Veri Sorumlusu</h2>
          <p>
            Kişisel verileriniz, veri sorumlusu sıfatıyla <strong>ViTex</strong> tarafından işlenmektedir.
          </p>
          <div className="legal-contact-box">
            <p><strong>Ticari Unvan:</strong> ViTex</p>
            <p><strong>E-posta:</strong> vitex.app@gmail.com</p>
            <p><strong>Adres:</strong> İstanbul, Türkiye</p>
          </div>
        </div>

        <div className="legal-section">
          <h2>2. İşlenen Kişisel Veriler ve İşleme Amaçları</h2>
          <table className="legal-table">
            <thead>
              <tr>
                <th>Kişisel Veri Kategorisi</th>
                <th>İşleme Amacı</th>
                <th>Hukuki Dayanak</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Ad, soyad, e-posta adresi</td>
                <td>Hesap oluşturma, kimlik doğrulama, iletişim</td>
                <td>Sözleşmenin ifası (m. 5/2-c)</td>
              </tr>
              <tr>
                <td>Şifreli parola (hash)</td>
                <td>Güvenli oturum yönetimi</td>
                <td>Sözleşmenin ifası (m. 5/2-c)</td>
              </tr>
              <tr>
                <td>Ad, soyad, adres, telefon (ödeme)</td>
                <td>Fatura düzenleme, ödeme işlemi, yasal yükümlülük</td>
                <td>Yasal yükümlülük (m. 5/2-ç) / Sözleşmenin ifası</td>
              </tr>
              <tr>
                <td>Kart bilgileri (son 4 hane)</td>
                <td>Ödeme doğrulama kaydı</td>
                <td>Sözleşmenin ifası (m. 5/2-c)</td>
              </tr>
              <tr>
                <td>Transkripsiyon geçmişi (dosya adı, süre, dil)</td>
                <td>Hizmet sunumu, kullanım takibi</td>
                <td>Sözleşmenin ifası (m. 5/2-c)</td>
              </tr>
              <tr>
                <td>Oturum ve yenileme tokenleri</td>
                <td>Güvenli oturum yönetimi</td>
                <td>Meşru menfaat (m. 5/2-f)</td>
              </tr>
              <tr>
                <td>Log kayıtları (IP, tarih/saat)</td>
                <td>Güvenlik, hata ayıklama</td>
                <td>Meşru menfaat (m. 5/2-f)</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="legal-section">
          <h2>3. Kişisel Verilerin Aktarılması</h2>
          <p>Kişisel verileriniz aşağıdaki taraflarla paylaşılabilmektedir:</p>
          <ul>
            <li>
              <strong>Iyzico Ödeme Hizmetleri A.Ş.:</strong> Ödeme işlemlerinin gerçekleştirilmesi amacıyla,
              yalnızca işlem için gerekli ödeme ve fatura bilgileri aktarılmaktadır. Kart bilgileriniz ViTex
              sunucularında saklanmamaktadır.
            </li>
            <li>
              <strong>Resend Inc.:</strong> İşlemsel e-postaların (şifre sıfırlama, doğrulama kodu) iletilmesi
              amacıyla e-posta adresi paylaşılmaktadır.
            </li>
            <li>
              <strong>Yasal Zorunluluklar:</strong> Yetkili kamu kurum ve kuruluşlarının talebi halinde ilgili
              mevzuat kapsamında kişisel veriler aktarılabilir.
            </li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>4. Kişisel Veri Toplama Yöntemi</h2>
          <p>
            Kişisel verileriniz; web sitesi üzerinden sunulan kayıt formu, giriş formu, ödeme formu ve masaüstü
            uygulama API bağlantısı aracılığıyla elektronik ortamda toplanmaktadır.
          </p>
        </div>

        <div className="legal-section">
          <h2>5. Kişisel Verilerin Saklama Süresi</h2>
          <p>
            Hesap verileri, hesabınız aktif olduğu sürece ve hesap silinmesinden itibaren 90 gün boyunca
            saklanmaktadır. Fatura ve ödeme kayıtları, Türk Ticaret Kanunu ve Vergi Usul Kanunu uyarınca
            10 yıl süreyle muhafaza edilmektedir. Log kayıtları en fazla 2 yıl saklanmaktadır.
          </p>
        </div>

        <div className="legal-section">
          <h2>6. İlgili Kişi Hakları (KVKK Madde 11)</h2>
          <p>Kanun'un 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:</p>
          <ul>
            <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
            <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,</li>
            <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
            <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri öğrenme,</li>
            <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme,</li>
            <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerinizin silinmesini veya
              yok edilmesini isteme,</li>
            <li>İşlemenin yalnızca otomatik sistemler aracılığıyla gerçekleştirilmesi durumunda aleyhinize
              bir sonucun ortaya çıkmasına itiraz etme,</li>
            <li>Kişisel verilerinizin kanuna aykırı işlenmesi sebebiyle zarara uğramanız hâlinde zararın
              giderilmesini talep etme.</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2>7. Başvuru Yöntemi</h2>
          <p>
            Yukarıda belirtilen haklarınızı kullanmak için kimliğinizi doğrulayan bilgiler ve talebinizle
            birlikte aşağıdaki iletişim kanallarından bize ulaşabilirsiniz. Başvurularınız 30 gün içinde
            yanıtlanacaktır.
          </p>
          <div className="legal-contact-box">
            <p><strong>E-posta:</strong> vitex.app@gmail.com</p>
            <p><strong>Konu:</strong> KVKK Başvurusu — [Ad Soyad]</p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
